/**
 *
 * EventRedirect
 *
 */

import { mapGetters } from 'vuex';

import { EVENT_URL, EVENT_TYPE_URL } from '@/constants/';

export default {
  name: 'EventRedirect',

  render: () => null,

  data() {
    return {
      redirect_uri: '',
    };
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),
  },

  created() {
    if (this.$route.query.type) {
      this.redirect_uri = 'http://' + EVENT_TYPE_URL;
      this.redirect_uri += '/' + this.$route.query.type;
      this.redirect_uri += '/' + this.$route.query.eid;
      this.redirect_uri += '/' + this.mg_userInfo.studentId;
      this.redirect_uri += '/' + this.$route.query.nonce;
    } else {
      if (this.$route.query.eventId) {
        this.redirect_uri = 'http://' + EVENT_URL;
        this.redirect_uri += '?eventId=' + this.$route.query.eventId;
        this.redirect_uri += '&studentId=' + this.mg_userInfo.studentId;
      }
    }
    window.location.href = this.redirect_uri;
  },
};
